<template>
  <ShoretelTMS title="Shoretel TMS Errors" />
</template>

<script>
import ShoretelTMS from "@/components/ShoretelTMS.vue";

export default {
  name: "ShoretelTMSView",
  components: {
    ShoretelTMS
  }
};
</script>
